import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA0EscYIzjEO8KjokLq6QJxKaXYPzqgefo",
  authDomain: "intelligentwriting-2c541.firebaseapp.com",
  projectId: "intelligentwriting-2c541",
  storageBucket: "intelligentwriting-2c541.firebasestorage.app",
  messagingSenderId: "844339042025",
  appId: "1:844339042025:web:3fe759fbc4349743d78278",
  measurementId: "G-1PWREPCBJV",
};

const app = initializeApp(firebaseConfig);

// Analytics працює тільки у браузері
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      getAnalytics(app);
    }
  });
}

export default app;